import { useContext } from "react";
import { Title } from "react-admin";
import {
  GridLayoutWidget,
} from "../../assets/maintenance-dashboard/common";
import { Breadcrumb } from "./Breadcrumb";
import { SelectedDriversFilterContext } from "./common";
import { SelectedDriversSlide } from "./SelectedDriversSlide";
import { TotalDrivers } from "./widgets/TotalDrivers";
import { HarshEventsBreakdown } from "./widgets/HarshEventsBreakdown";
import "./SafetyDashboard.css";
import { DriversScore } from "./widgets/DriversScore";
import { GeometrisAlerts } from "./widgets/GeometrisAlerts";
import { SpeedingEventsSummary } from "./widgets/SpeedingEventsSummary";

const widgets: GridLayoutWidget[] = [
  {
    i: "harshEvents",
    Widget: HarshEventsBreakdown,
    icon: "warning",
    title: "Drivers with harsh events",
  },
  {
    i: "totalDrivers",
    Widget: TotalDrivers,
    icon: "info",
    title: "Active drivers",
  },
  {
    i: "safetyScore",
    Widget: DriversScore,
    icon: "info",
    title: "Drivers safety score",
  },
  {
    i: "geometrisAlerts",
    Widget: GeometrisAlerts,
    icon: "warning",
    title: "Harsh events",
  },
  {
    i: "speedingLocations",
    Widget: SpeedingEventsSummary,
    icon: "error",
    title: "Speeding summary",
  },
];


export const SafetyDashboard = () => {
  const context = useContext(SelectedDriversFilterContext);
  const sidebarVisible = !!context?.selectedFilter;
  return (
    <>
      <Title title={<Breadcrumb />} />
      <div className="safety-dashboard">
        {widgets.map((x) => (
          <x.Widget key={x.i} icon={x.icon} title={x.title} />
        ))}
        {sidebarVisible ? <SelectedDriversSlide /> : null}
      </div>
    </>
  );
};
